import { AppDownload } from './AppDownload';
import { EmailConfirmation } from './EmailConfirmation';
import Login from './Login/LoginFlow';
import NotificationLogin from './Login/NotificationFlow';
import SignUp from './Login/SignUpFlow';
import { ProductNotification } from './ProductNotification';

export default {
  AppDownload,
  EmailConfirmation,
  Login,
  NotificationLogin,
  ProductNotification,
  SignUp
};
